var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donate_content"},[_c('img',{staticClass:"donate_content_img",attrs:{"src":_vm.returnImage()},on:{"click":_vm.moveDonate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }